import { produce } from 'immer';
import { compact } from 'lodash';
import { version } from '../../constants';
import { CONTAINS, EQUALS, HAS_KEY, ONE_OF, STRICT_EQUAL } from '../../operators';
import {
    ACTION_ADD_CONDITION,
    ACTION_ADD_SUB_CONDITION,
    ACTION_ADD_VALUE,
    ACTION_CHANGE_OPERATOR,
    ACTION_CHANGE_VALUE,
    ACTION_REMOVE_CONDITION,
    ACTION_REMOVE_SUB_CONDITION,
    ACTION_REPLACE_FIELD,
    ACTION_SET_QUERY,
} from '../actions/query';
import { ACTION_REPLACE_INVALID_FIELD } from '../actions/requiredUserActions';

const DEFAULT_STATE = {
    version: version,
    AND: [],
};

export const OPERATORS_WITH_VALUES_PROPERTY = [ONE_OF, EQUALS, CONTAINS, STRICT_EQUAL, HAS_KEY],
    OPERATORS_THAT_ALLOW_EMPTY_VALUES = [STRICT_EQUAL];

export const queryReducer = (state, action) => {
    if (!state) state = DEFAULT_STATE;

    //
    // NOTE: this reducer uses Immer for immutability
    //

    return produce(state, (draft) => {
        const { conditionIndex, subConditionIndex, fieldId, valueIndex, operatorId, value } = action;

        switch (action.type) {
            case ACTION_SET_QUERY:
                for (let prop in state) {
                    draft[prop] = action.query[prop] ?? state[prop];
                }
                break;
            case ACTION_REPLACE_FIELD:
                draft.AND[conditionIndex].OR[subConditionIndex].field = fieldId;
                break;

            case ACTION_ADD_VALUE:
                draft.AND[conditionIndex].OR[subConditionIndex].values.push(value);
                break;

            case ACTION_CHANGE_VALUE:
                if (!state.AND[conditionIndex].OR[subConditionIndex].values) {
                }
                draft.AND[conditionIndex].OR[subConditionIndex].values[valueIndex] = value;
                if (!OPERATORS_THAT_ALLOW_EMPTY_VALUES.includes(draft.AND[conditionIndex].OR[subConditionIndex].operator)) {
                    draft.AND[conditionIndex].OR[subConditionIndex].values = compact(draft.AND[conditionIndex].OR[subConditionIndex].values);
                }
                break;

            case ACTION_CHANGE_OPERATOR:
                draft.AND[conditionIndex].OR[subConditionIndex].operator = operatorId;
                break;

            case ACTION_ADD_SUB_CONDITION:
                let newCondition = {
                    field: action.field,
                    operator: action.operator,
                };
                if (action.values) {
                    newCondition.values = action.values;
                }
                draft.AND[conditionIndex].OR.push(newCondition);
                break;

            case ACTION_REMOVE_SUB_CONDITION:
                draft.AND[conditionIndex].OR.splice(subConditionIndex, 1);
                break;

            case ACTION_ADD_CONDITION:
                draft.AND.push({
                    category: action.categoryId,
                    OR: [],
                });
                break;

            case ACTION_REMOVE_CONDITION:
                draft.AND.splice(conditionIndex, 1);
                break;

            case ACTION_REPLACE_INVALID_FIELD:
                for (let invalidField of action.invalidFields) {
                    draft.AND[invalidField.conditionIndex].OR.push({
                        ...invalidField.subCondition,
                        field: action.newField,
                    });
                }
                break;
        }

        // apply defaults or cleanup unused props
        for (let condition of draft.AND) {
            for (let subCondition of condition.OR) {
                if (OPERATORS_WITH_VALUES_PROPERTY.includes(subCondition.operator)) {
                    if (!subCondition.values) {
                        subCondition.values = [];
                    }
                } else if ('values' in subCondition) {
                    delete subCondition.values;
                }
            }
        }
    });
};
